import type { Line } from "../render/Line";
import type { CsClient } from "../net/csClient";
import { AudioToy } from "./AudioToy";

// CsClient stand-in for ?play mode. No WebSocket: instead of broadcasting
// events, it drives a local WebAudio synth so the playground is actually
// audible. Looks up the line's wavelength via the supplied lines array.
export class PlaygroundClient extends EventTarget implements CsClient {
  readonly connected = true;
  private audio = new AudioToy();
  private linesRef: { current: Line[] };
  private lastFingerLine = new Map<number, number>(); // finger → line idx

  constructor(linesRef: { current: Line[] }) {
    super();
    this.linesRef = linesRef;
    queueMicrotask(() => this.dispatchEvent(new Event("connected")));
  }

  sendNoteOn(line: number, finger: number) {
    const li = this.linesRef.current[line];
    if (!li) return;
    this.lastFingerLine.set(finger, line);
    this.audio.noteOn(line, finger, li.data.wavelengthNm);
  }

  sendNoteOff(line: number, finger: number) {
    this.audio.noteOff(line, finger);
    if (this.lastFingerLine.get(finger) === line) this.lastFingerLine.delete(finger);
  }

  sendFingerUV(finger: number, u: number, v: number) {
    const line = this.lastFingerLine.get(finger);
    if (line === undefined) return;
    this.audio.setUV(line, finger, u, v);
  }

  setMuted(muted: boolean) {
    this.audio.setMuted(muted);
  }
}
